import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const appClasses = {
  root: css`
    block-size: ${spacing(20)};

    & > *:first-child {
      margin-inline-end: ${spacing(2.125)};
    }
  `,
  stores: css`
    min-inline-size: max-content;

    & > *:not(:last-child) {
      margin-block-end: ${spacing(1.25)};
    }
  `,
}
